import { render, staticRenderFns } from "./4EventManagement.vue?vue&type=template&id=582c8ce8&scoped=true&"
import script from "./4EventManagement.vue?vue&type=script&lang=js&"
export * from "./4EventManagement.vue?vue&type=script&lang=js&"
import style0 from "./4EventManagement.vue?vue&type=style&index=0&id=582c8ce8&scoped=true&lang=css&"
import style1 from "./4EventManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582c8ce8",
  null
  
)

export default component.exports